import React, { useContext, useState } from "react";
import { useForm } from "react-hook-form";
import { Button } from "rizzui/button";
import { Password } from "rizzui/password";
import { Text } from "rizzui/typography";
import { inputClassName, labelClassName } from "../../projects/new/first";
import { useNavigate } from "react-router";
import { useQuery } from "@tanstack/react-query";
import { baseUrl } from "../../account/login";
import axios from "axios";
import { AuthContext } from "../../../context/authContext";
import { useNotifcication } from "../../../hooks/useNotification";

export default function ChangePassword() {
  const navigate = useNavigate();
  const { openNotification } = useNotifcication();
  const { token } = useContext(AuthContext);
  const AuthStr = "Bearer ".concat(token);
  const {
    data: passwordChange,
    isLoading,
    error,
    refetch,
  } = useQuery({
    queryKey: ["change_password", token],
    queryFn: async () => {
      const { currentPassword, newPassword, confirmPassword } = getValues();
      return axios
        .post(
          `${baseUrl}/profile/change_password`,
          {
            old_password: currentPassword,
            new_password: newPassword,
            confirm_password: confirmPassword,
          },
          { headers: { Authorization: AuthStr } }
        )
        .then((response) => {
          if (response.status === 200) {
            /*localStorage.removeItem("isLogin");
            localStorage.removeItem("token");
             navigate("/account/login", {
              state: { message: "password-changed" },
            }); */
            openNotification({
              status: "success",
              message: "Password changed",
            });
          }
          return response;
        })
        .catch((e) => {
          return Promise.reject(new Error("Incorrect Password"));
        });
    },
    retry: 0,
    enabled: false,
  });

  const {
    handleSubmit,
    register,
    formState: { errors },
    watch,
    getValues,
  } = useForm();

  const handlePasswordChange = handleSubmit((data) => {
    refetch();
  });

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        handlePasswordChange();
      }}
      className="flex flex-col gap-[24px] w-[315px] mt-[49px]"
      noValidate
    >
      <Password
        label="Current password"
        labelClassName={labelClassName}
        inputClassName={inputClassName}
        {...register("currentPassword", {
          required: "Required",
        })}
        error={
          errors?.currentPassword ? "" + errors?.currentPassword?.message : ""
        }
      />

      <Password
        label="New password"
        labelClassName={labelClassName}
        inputClassName={inputClassName}
        {...register("newPassword", {
          required: "Required",
        })}
        error={errors?.newPassword ? "" + errors?.newPassword?.message : ""}
      />
      <Password
        label="Confirm new password"
        labelClassName={labelClassName}
        inputClassName={inputClassName}
        {...register("confirmPassword", {
          validate: (value) => {
            const password = watch("newPassword");
            if (password !== value) return "Passwords do not match";
          },
        })}
        error={errors.confirmPassword?.message ? "Passwords do not match" : ""}
      />

      <Button
        variant="solid"
        type="submit"
        className="h-[40px] text-[14px] font-[500] leading-[18.48px] font-switzer text-background !bg-btn rounded-[4px]"
        isLoading={isLoading}
      >
        Set a new password
      </Button>
      {error && (
        <Text className="font-switzer -mt-[16px] text-[12px] text-[#E63946]">
          {error.message}
        </Text>
      )}
    </form>
  );
}
